// Generated by Melange

import SongListModuleCss from "./songList.module.css";
import * as Belt__Belt_Array from "melange.belt/belt_Array.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Shared__SongRow from "./songRow.jsx";
import * as Stdlib__Int from "melange/int.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import Clsx from "clsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = SongListModuleCss;

const make = React.memo(function (Props) {
  let getSongElementId = Props.getSongElementId;
  let isAlbumViewOpt = Props.isAlbumView;
  let isCompilationOpt = Props.isCompilation;
  let isQueueViewOpt = Props.isQueueView;
  let primaryArtist = Props.primaryArtist;
  let songIds = Props.songIds;
  let songIdsToPlayOpt = Props.songIdsToPlay;
  const isAlbumView = isAlbumViewOpt !== undefined ? isAlbumViewOpt : false;
  const isCompilation = isCompilationOpt !== undefined ? isCompilationOpt : false;
  const isQueueView = isQueueViewOpt !== undefined ? isQueueViewOpt : false;
  const songIdsToPlay = songIdsToPlayOpt !== undefined ? Caml_option.valFromOption(songIdsToPlayOpt) : songIds;
  const arg = Belt__Belt_Array.make(5, undefined);
  return JsxRuntime.jsx("div", {
    children: (function (param) {
      return Stdlib__Option.value(param, arg);
    })(Stdlib__Option.map((function (param) {
      return param.map(Stdlib__Option.some);
    }), songIds)).map(function (songId, index) {
      const arg = Stdlib__Int.to_string(index);
      const Key = (function (param) {
        return Stdlib__Option.value(param, arg);
      })(songId);
      let tmp = {
        isAlbumView: isAlbumView,
        isCompilation: isCompilation,
        isQueueView: isQueueView,
        songId: songId
      };
      const tmp$1 = songId !== undefined && getSongElementId !== undefined ? Stdlib__Option.some(Curry._1(getSongElementId, songId)) : undefined;
      if (tmp$1 !== undefined) {
        tmp.elementId = Caml_option.valFromOption(tmp$1);
      }
      if (primaryArtist !== undefined) {
        tmp.primaryArtist = Caml_option.valFromOption(primaryArtist);
      }
      if (songIdsToPlay !== undefined) {
        tmp.songIdsToPlay = Caml_option.valFromOption(songIdsToPlay);
      }
      return JsxRuntime.jsx(Shared__SongRow.make, tmp, Key);
    }),
    className: Clsx(css.root, isAlbumView ? css.root_albumView : undefined)
  });
});

export {
  make,
}
/* css Not a pure module */
